import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import Benefits1 from "/Images/benefits1.svg"; // Import benefit images
import Benefits2 from "/Images/benefits2.svg";
import Benefits3 from "/Images/benefits3.svg";
import Benefits4 from "/Images/benefits4.svg";
import CheckIcon from "/Images/cekidot.svg"; // Import check icon




const DeploymentSection = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const benefits = [
    {
      icon: Benefits1,
      title: "Infrastructure Security",
      description: [
        "Tennet’s infrastructure runs on data centers in Indonesia with banking-grade security controls and industry-standard certifications.",
        "All our IT systems require multi-factor authentication and follow segregation of duty principles.",
        "We have 24/7 security monitoring and incident response capabilities.",
      ],
    },
    {
      icon: Benefits2,
      title: "Internal Controls",
      description: [
        "Tennet implements the three lines of defense model, composed of process owners, risk & compliance, internal & external audit.",
        "All our staff undergoes background checks and training sessions about security awareness, regulatory compliance, and data protection.",
        "Tennet is expecting ISO:27001 certification validation in 2024.",
      ],
    },
    {
      icon: Benefits3,
      title: "Security Audits",
      description: [
        "We hire world-class teams to pentest our applications and review our source code.",
        "Clients of our custody solution can organize their own pentests of our solution, and can receive a copy of our product’s source code.",
        "Our proprietary trusted build system certifies that a binary was built from a given source code version, via an external auditor certification.",
      ],
    },
    {
      icon: Benefits4,
      title: "Security Research",
      description: [
        "Our internal research unit performs research projects and collaborates with world-class researchers.",
        "We publish open-source software, research articles, and give talks at top-tier global events.",
        "Tennet has helped leading blockchain organizations to strengthen their security protocols.",
      ],
    },
  ];
  
  const styles = {
    container: {
      backgroundColor: "#E0DCD9",
      padding: "3rem 5%",
      borderRadius: "10px",
    },
    title: {
      fontWeight: 'bold',
      background: 'linear-gradient(90deg, #2D669B 0%, #0582CA 100%)',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      color: 'transparent',
      marginBottom: '4rem',
      fontSize: isMobile ? "30px" : "40px",
      textAlign: "center", // Set rata tengah
      fontFamily:"Poppins",
      marginTop:"2rem",
      width: isMobile? "auto":"606px",
      marginLeft: "auto",
      marginRight: "auto",
      lineHeight:"50px"


    },
    
    card: {
      backgroundColor: "#E8E4E1",
      padding: isMobile? "2rem" : "4.5rem",
      paddingTop:"3rem",
      borderRadius: "10px",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Box shadow effect
      display: "flex",
      flexDirection: "column",
      alignItems: isMobile?  "center":"flex-start",
 
      flex: "1 1 48%", // Allows two cards per row with a small gap
      maxWidth: "550px",
      minHeight: "554px",
      gap: "1rem",
      marginBottom: "1rem", // Adds space below each card
      textAlign:"justify",
    },
    icon: {
      width: "85px",
      height: "85px",
      marginBottom: "1rem",
    },
    cardTitle: {
      color: "#214D73",
      fontWeight: "600",
      fontSize: "30px",
      marginBottom: "0.5rem",
      textAlign: "center", // Set rata tengah

      
    },
    listItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: "10px",
      marginBottom: "10px",
      maxWidth:"400px",
  
    },
    listIcon: {
      height: "18px",
      marginTop: "4px",
    },
    listDescription: {
      fontSize: "1rem",
      color: "#6D6D6D",
      lineHeight: "1.5",
      maxWidth:"471px",
     },
    cardsContainer: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center", // Aligns cards to the start with no space between
      gap: "1rem", // Adjust gap if needed
    },
  };
  return (
    <div style={styles.container}>
      <Typography style={styles.title}>
        Benefits of Tennet’s Services for Institutions
      </Typography>
      <Box style={styles.cardsContainer}>
        {benefits.map((benefit, index) => (
          <Box key={index} style={styles.card}>
            <img src={benefit.icon} alt={benefit.title} style={styles.icon} />
            <Typography style={styles.cardTitle}>{benefit.title}</Typography>
            {benefit.description.map((desc, i) => (
              <div style={styles.listItem} key={i}>
                <img src={CheckIcon} alt="Check" style={styles.listIcon} />
                <Typography style={styles.listDescription}>{desc}</Typography>
              </div>
            ))}
          </Box>
        ))}
      </Box>
    </div>
  );
};

export default DeploymentSection;
